module.exports = __webpack_public_path__ + "static/media/city.38a84dc4.svg";